/** 4F 地址（接真实接口后替换 id；当前仅展示底图） */
export const F4_ADDRESS = {
  id: '',
  name: '4F',
  display: '4F'
}
